import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "product-awards__top product-awards-list__top" }
const _hoisted_2 = {
  key: 0,
  class: "product-awards-list__filter"
}
const _hoisted_3 = { class: "product-awards-list__select" }
const _hoisted_4 = { class: "product-awards-list__select-label" }
const _hoisted_5 = {
  key: 1,
  class: "product-awards-list__container"
}
const _hoisted_6 = { class: "product-awards-list__tile-header" }
const _hoisted_7 = { class: "product-awards-list__text-rater" }
const _hoisted_8 = {
  key: 0,
  class: "product-awards-list__text-rating"
}
const _hoisted_9 = {
  key: 1,
  class: "product-awards-list__text-vintage"
}
const _hoisted_10 = { class: "product-awards-list__tile-content" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "product-awards-list__tile-text product-awards-list__tile-text--quote detailAwardShortText"
}
const _hoisted_13 = { class: "product-awards-list__tile-text--quote-inner" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 2,
  class: "product-awards-list__more-content"
}
const _hoisted_18 = ["id"]
const _hoisted_19 = {
  key: 0,
  class: "product-awards__item product-awards__item--scala"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 1,
  class: "product-awards__item product-awards__item--premium"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "product-awards__item-wrapper" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 2,
  class: "product-awards-list__link-rater"
}
const _hoisted_32 = ["href", "title"]
const _hoisted_33 = ["for"]
const _hoisted_34 = { class: "product-awards-list__more-button" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 3,
  class: "product-awards-list__more-link-rater"
}
const _hoisted_37 = ["href", "title"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "product-awards-list__link-text" }
const _hoisted_40 = {
  key: 2,
  class: "product-awards__no-awards"
}
const _hoisted_41 = { class: "product-awards__vintage-link-list" }
const _hoisted_42 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_vue = _resolveComponent("select-vue")!
  const _component_image_element = _resolveComponent("image-element")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-awards-list", {
      'product-awards-list--no-awards': _ctx.filteredAwards.length < 1,
      'product-awards-list--no-filter': _ctx.vintageOptions.length < 3
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.vintageOptions.length >= 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('awards.filterBy')), 1 /* TEXT */),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createVNode(_component_select_vue, {
                class: "product-awards__select select--formless",
                modelValue: _ctx.selectedFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFilter) = $event)),
                name: "filter",
                options: _ctx.allVintagesOptions,
                "initial-value": _ctx.selectedFilter,
                ref: "vintageSelectRef"
              }, null, 8 /* PROPS */, ["modelValue", "options", "initial-value"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _cache[23] || (_cache[23] = _createTextVNode()),
      (_ctx.reviewsPresentForCurrentVintage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAwards, (award, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: award.hash,
                class: _normalizeClass(["product-awards-list__tile", {'product-awards-list__tile--hidden': (index > 2 && !_ctx.showAllTiles)}])
              }, [
                (award.raterImage)
                  ? (_openBlock(), _createBlock(_component_image_element, {
                      key: 0,
                      class: "product-awards-list__tile-image",
                      src: [award.raterImage.big],
                      alt: _ctx.$t('awards.image.alt', [award.rater]).toString()
                    }, null, 8 /* PROPS */, ["src", "alt"]))
                  : (award.logo && award.logo.big)
                    ? (_openBlock(), _createBlock(_component_image_element, {
                        key: 1,
                        class: "product-awards-list__tile-image",
                        src: [award.logo.big],
                        alt: _ctx.$t('awards.image.alt', [award.rater]).toString()
                      }, null, 8 /* PROPS */, ["src", "alt"]))
                    : _createCommentVNode("v-if", true),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(award.rater), 1 /* TEXT */),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  _createElementVNode("div", null, [
                    (award.rating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.formatRatingText(award.rating)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (award.vintage)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('awards.vintage', [award.vintage.toString()])), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createElementVNode("div", _hoisted_10, [
                  (award.detailAwardLongText)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "product-awards-list__tile-text detailAwardLongText",
                        innerHTML: award.detailAwardLongText
                      }, null, 8 /* PROPS */, _hoisted_11))
                    : _createCommentVNode("v-if", true),
                  _cache[5] || (_cache[5] = _createTextVNode()),
                  (award.detailAwardShortText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("blockquote", {
                            innerHTML: _ctx.formatHTMLtoText(award.detailAwardShortText)
                          }, null, 8 /* PROPS */, _hoisted_14)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _cache[6] || (_cache[6] = _createTextVNode()),
                  (award.detailPublisher)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "product-awards-list__tile-text detailPublisher",
                        innerHTML: award.detailPublisher
                      }, null, 8 /* PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true),
                  _cache[7] || (_cache[7] = _createTextVNode()),
                  (award.detailPublication !== award.rater)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: _normalizeClass(["product-awards-list__text-detail-publication", {'product-awards-list__text-detail-publication-margin' : (!award.detailAwardShortText && !award.detailAwardLongText)}])
                      }, [
                        _createElementVNode("span", {
                          innerHTML: award.detailPublication
                        }, null, 8 /* PROPS */, _hoisted_16)
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                (award.detailShortRaterText || award.detailShortScaleText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        id: `product-awards-list__more-id-${index}`,
                        class: "product-awards-list__more-checkbox"
                      }, null, 8 /* PROPS */, _hoisted_18),
                      _cache[14] || (_cache[14] = _createTextVNode()),
                      (award.detailShortScaleText || (award.raterScaleImage && award.raterScaleImage.big))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", {
                              class: "product-awards__item-headline",
                              innerHTML: _ctx.$t('awards.scale.description')
                            }, null, 8 /* PROPS */, _hoisted_20),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            (award.raterScaleImage && award.raterScaleImage.big)
                              ? (_openBlock(), _createBlock(_component_image_element, {
                                  key: 0,
                                  "img-class": "product-awards__item-image",
                                  src: [award.raterScaleImage.big],
                                  alt: _ctx.$t('awards.scale.description')
                                }, null, 8 /* PROPS */, ["src", "alt"]))
                              : _createCommentVNode("v-if", true),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            (award.detailShortScaleText)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "product-awards__item-text",
                                  innerHTML: award.detailShortScaleText
                                }, null, 8 /* PROPS */, _hoisted_21))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _cache[15] || (_cache[15] = _createTextVNode()),
                      (award.rater || award.detailRaterSubHeadline || award.detailShortRaterText || award.raterLink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: "product-awards__item-headline",
                              innerHTML: _ctx.$t('awards.rater.description')
                            }, null, 8 /* PROPS */, _hoisted_23),
                            _cache[12] || (_cache[12] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_24, [
                              (award.rater)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("div", {
                                      class: "product-awards__item-text product-awards__item-text--rater",
                                      innerHTML: award.rater
                                    }, null, 8 /* PROPS */, _hoisted_26)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _cache[10] || (_cache[10] = _createTextVNode()),
                              (award.detailRaterSubHeadline)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", {
                                      class: "product-awards__item-text product-awards__item-text--detailRaterSubHeadline",
                                      innerHTML: award.detailRaterSubHeadline
                                    }, null, 8 /* PROPS */, _hoisted_28)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _cache[11] || (_cache[11] = _createTextVNode()),
                              (award.detailShortRaterText)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("div", {
                                      class: "product-awards__item-text product-awards__item-text--detailShortRaterText",
                                      innerHTML: award.detailShortRaterText
                                    }, null, 8 /* PROPS */, _hoisted_30)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _cache[16] || (_cache[16] = _createTextVNode()),
                      (award.raterLink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("a", {
                              class: "product-awards-list__link-text",
                              href: award.raterLink,
                              title: `${_ctx.$t('awards.details.button')}: ${award.rater}`
                            }, _toDisplayString(_ctx.$t('awards.link', [award.rater.toString()])), 9 /* TEXT, PROPS */, _hoisted_32)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _cache[17] || (_cache[17] = _createTextVNode()),
                      _createElementVNode("label", {
                        for: `product-awards-list__more-id-${index}`,
                        class: "product-awards-list__more-label"
                      }, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('awards.details.button')), 1 /* TEXT */),
                        _cache[13] || (_cache[13] = _createTextVNode()),
                        _createElementVNode("span", {
                          class: "product-awards-list__less-button",
                          onClick: ($event: any) => (_ctx.scrollToContent(index))
                        }, _toDisplayString(_ctx.$t('awards.details.lessButton')), 9 /* TEXT, PROPS */, _hoisted_35)
                      ], 8 /* PROPS */, _hoisted_33)
                    ]))
                  : _createCommentVNode("v-if", true),
                _cache[21] || (_cache[21] = _createTextVNode()),
                (award.raterLink && !award.detailShortRaterText && !award.detailShortScaleText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("a", {
                        class: "product-awards-list__link-text",
                        href: award.raterLink,
                        title: `${_ctx.$t('awards.details.button')}: ${award.rater}`
                      }, _toDisplayString(_ctx.$t('awards.link', [award.rater.toString()])), 9 /* TEXT, PROPS */, _hoisted_37)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */)),
            _cache[22] || (_cache[22] = _createTextVNode()),
            (_ctx.filteredAwards.length > 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "product-awards-list__button",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleShowAllTiles()))
                  }, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.showAllTiles ? _ctx.$t('awards.btn.less') : _ctx.$t('awards.btn.more')), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_ctx.uniqueAwardsVintageList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createTextVNode(_toDisplayString(_ctx.$t('awards.no_awards_for_vintage_but_others')) + " ", 1 /* TEXT */),
              _createElementVNode("ul", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueAwardsVintageList, (vintage) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: vintage,
                    onClick: ($event: any) => (_ctx.selectVintage(vintage)),
                    class: "product-awards__vintage-link"
                  }, _toDisplayString(vintage), 9 /* TEXT, PROPS */, _hoisted_42))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}